<template>
    <div
        class="bullet"
        :class="{ active: level.key, complete: level.value >= requiredLevel.value }"
    >
    </div>
</template>

<script>
export default {
    name: "Bullet",
    
    props: {
        level: {
            type: Object,
            default: () => {},
        },

        requiredLevel: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.bullet {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: url("~@/assets/images/account-track/icon/competences/competence-default.svg") no-repeat center/contain;

    @include on-xs {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/account-track/icon/competences/competence-default-mobile.svg");
    }

    &.active {
        background-image: url("~@/assets/images/account-track/icon/competences/competence.svg");

        @include on-xs {
            background-image: url("~@/assets/images/account-track/icon/competences/competence-mobile.svg");
        }
    }

    &.complete {
        background-image: url("../../../../../../assets/images/account-track/icon/competences/competence-complete.svg");

        @include on-xs {
            background-image: url("../../../../../../assets/images/account-track/icon/competences/competence-complete-mobile.svg");
        }
    }
}
</style>